import { ENTITIES } from 'src/models/QuerybuilderModel';
import { useSelector } from 'react-redux';
import { Store } from 'src/redux/Store';
import UnselectAllMenubutton from 'src/components/Control/Buttons/UnselectAllMenuButton';
import SelectAllMenubutton from 'src/components/Control/Buttons/SelectAllMenuButton';
import ConfigureColumnsButton from 'src/components/Control/Buttons/ConfigureColumnsButton';
import { FundraisingTransaction } from 'src/models/FundraisingModel';
import DownloadPaymentButton from 'src/components/Control/Buttons/DownloadPaymentButton';
import ShowInvoiceTransactionButton
  from 'src/components/Control/Buttons/ShowInvoiceTransactionButton';
import ShowPaymentTransactionButton
  from 'src/components/Control/Buttons/ShowPaymentTransactionButton';
import EditTransactionButton from 'src/components/Control/Buttons/EditTransactionButton';

const FundraisingTransactionsToolbar = () => {
  const selections = useSelector(
    (state: Store) => state.selected[ENTITIES.fundraisingTransactions] || [],
  );

  const fundraisingTransactions = useSelector(
    (state: Store) => {
      if (selections.length === 0) return {} as FundraisingTransaction;
      if (!state.fundraisingTransaction[selections[0]]) return {} as FundraisingTransaction;
      return state.fundraisingTransaction[selections[0]] as FundraisingTransaction;
    },
  );

  const paymentId = fundraisingTransactions?.payment_id || 0;
  const invoiceId = fundraisingTransactions?.invoice_id || 0;

  return (

    <>
      <EditTransactionButton />
      <DownloadPaymentButton paymentId={paymentId} />
      <ShowPaymentTransactionButton paymentId={paymentId} />
      <ShowInvoiceTransactionButton invoiceId={invoiceId} />
      <ConfigureColumnsButton
        entity={ENTITIES.fundraisings} />
      <UnselectAllMenubutton
        entity={ENTITIES.fundraisings}
        disabled={!selections.length} />
      <SelectAllMenubutton
        entity={ENTITIES.fundraisings} />
    </>
  );
};
export default FundraisingTransactionsToolbar;
